import React, {useEffect, useState} from "react";
import {
    isMobileVerticalScreen,
} from "../../../utils/displayUtils";
import {
    URL_PAYMENTS,
    URL_ROOT,
    URL_STATISTIC,
} from "../../../properties";
import {pathParameter} from "../../../utils/urlUtils";
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {logout} from "../../../actions/authActions";
import {executeSync} from "../../../utils/syncUtils";
import {loadPartnerBalance} from "../../../actions/partnerBalanceActions";
import {loadChatHistory, toggleOpenChat} from "../../../actions/chatActions";
import {loadHeaderNews, readNewsItem} from "../../../actions/newsActions";
import useScreenSize from "../../../hooks/useScreenSize";
import useThemeToggle from "../../../hooks/useThemeToggle";
import PageHeaderView from "./PageHeaderView";
import {
    getHeaderBalance,
    getHeaderPartnerName,
    getHeaderPaymentsUrl,
    getHeaderProfileUrl,
    getUnreadNewsItemsAmount
} from "./pageHeaderModel";
import {MANAGER_MAIN} from "../../../utils/constants";

const MAX_NEWS_PER_LOAD = 7;

export default function PageHeader() {
    const dispatch = useDispatch();
    const partnerBalance = useSelector(state => state.partnerBalanceReducer.balance);
    const auth = useSelector(state => state.auth);
    const isChatOpened = useSelector(state => state.chatReducer.isChatOpened);
    const numberOfUnreadMessages = useSelector(state => state.chatReducer.numberOfUnreadMessages);
    const news = useSelector(state => state.newsReducer.headerNews);
    const {isAdminAsPartner, isPartner} = auth;

    const history = useHistory();
    const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);
    const [isNewsPopupOpen, setIsNewsPopupOpen] = useState(false);
    const {toggleTheme} = useThemeToggle();
    const isPartnerPage = isAdminAsPartner || isPartner;

    const screenSizeWidth = useScreenSize()?.width || 0;
    const isMobileVertical = isMobileVerticalScreen();
    const isDesktop = screenSizeWidth >=1024;
    const displayEmail = screenSizeWidth > 650;

    useEffect(() => {
        dispatch(loadHeaderNews(MAX_NEWS_PER_LOAD, null));
    }, [dispatch]);

    useEffect(() => {
        if (isPartnerPage) {
            dispatch(loadPartnerBalance());
        }
    }, [dispatch, isPartnerPage]);

    useEffect(() => {
        if (displayEmail && isMobilePopupOpen) {
            setIsMobilePopupOpen(false);
        }
    }, [displayEmail, isMobilePopupOpen]);

    const redirectToFin = () => {
        history.push(getHeaderPaymentsUrl(isAdminAsPartner, pathParameter("partnerId")));
    };

    const handleLogout = () => {
        executeSync(() => dispatch(logout()))
            .then(() => {
                if (isAdminAsPartner) {
                    window.location.assign(URL_STATISTIC + "?type=" + MANAGER_MAIN);
                    return;
                }

                history.push(URL_ROOT);
            });
    };

    const redirectToProfile = () => {
        const partnerId = pathParameter("partnerId");
        history.push(getHeaderProfileUrl(partnerId));
    };

    const togglePopupOpen = () => {
        setIsMobilePopupOpen(currentValue => !currentValue);
        setIsNewsPopupOpen(false);
    };

    const toggleChat = () => {
        !isChatOpened && dispatch(loadChatHistory());
        dispatch(toggleOpenChat(!isChatOpened));
    };

    const toggleOpenNewsPopup = () => {
        setIsNewsPopupOpen(currentValue => !currentValue);
    };

    const readItem = (newsItem) => {
        dispatch(readNewsItem(newsItem, () => dispatch(loadHeaderNews(news.length, null))));
    };

    const loadMoreNews = () => {
        dispatch(loadHeaderNews(MAX_NEWS_PER_LOAD, news?.length > 0 ? news[news.length - 1].id : null));
    };

    const balance = getHeaderBalance(partnerBalance);
    const partnerName = getHeaderPartnerName(isPartnerPage, partnerBalance);
    const notReadItemsAmount = getUnreadNewsItemsAmount(news);

    return (
        <PageHeaderView
            balance={balance}
            partnerName={partnerName}
            isPartnerPage={isPartnerPage}
            isDesktop={isDesktop}
            isMobileVertical={isMobileVertical}
            displayEmail={displayEmail}
            isMobilePopupOpen={isMobilePopupOpen}
            isNewsPopupOpen={isNewsPopupOpen}
            notReadItemsAmount={notReadItemsAmount}
            numberOfUnreadMessages={numberOfUnreadMessages}
            news={news}
            onToggleMobilePopup={togglePopupOpen}
            onToggleNewsPopup={toggleOpenNewsPopup}
            onToggleChat={toggleChat}
            onToggleTheme={toggleTheme}
            onLogout={handleLogout}
            onRedirectToFin={redirectToFin}
            onRedirectToProfile={redirectToProfile}
            onReadNewsItem={readItem}
            onLoadMoreNews={loadMoreNews}
        />
    );
}
